import { render, staticRenderFns } from "./freightTrack.vue?vue&type=template&id=33c1f40a&scoped=true"
import script from "./freightTrack.vue?vue&type=script&lang=js"
export * from "./freightTrack.vue?vue&type=script&lang=js"
import style0 from "./freightTrack.vue?vue&type=style&index=0&id=33c1f40a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c1f40a",
  null
  
)

export default component.exports